import { createStyles, makeStyles } from '@material-ui/core';
import { BrandingWatermark } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useDocumentPermissions, useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});
/**
 * Document widget component that toggles the displaying of the watermark
 */
export const ToggleWatermarkWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  const permissions = useDocumentPermissions();
  return /*#__PURE__*/React.createElement(ToggleBase, {
    disabled: !permissions.canHideWatermark,
    classes: classes,
    title: localization.toggleWatermark,
    active: viewerState.showWatermark,
    setValue: v => viewerState.updateState({
      showWatermark: v
    })
  }, /*#__PURE__*/React.createElement(BrandingWatermark, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.showWatermark
    })
  }));
};
//# sourceMappingURL=toggle-watermark.js.map